import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import {loadGuidePage} from './lib/guidePageLoader.js';
import {loadClassPage} from './lib/classPageLoader.js';
import { loadTeamPage } from './lib/teamPageLoader.js';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/manrope/latin-600.css';
import '@fontsource/manrope/latin-700.css';
import './styles/index.css';
// Keep static hero styles in the initial CSS; the phone's styles stay deferred.
import './pages/seo/teamLanding.css';

async function mount() {
  // Keep the visible prerendered document until the SEO route module is ready.
  // Passing the resolved component avoids a Suspense fallback on initial boot.
  const teamPage = /^\/tjana-pengar-till-laget\/?$/.test(location.pathname)
    ? (await loadTeamPage()).default : undefined;
  const classPage = /^\/klassforsaljning\/?$/.test(location.pathname) ? (await loadClassPage()).default : undefined;
  const guidePage=/^\/tjana-pengar-till-klassresan\/?$/.test(location.pathname) ? (await loadGuidePage()).default : undefined;
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode><App initialTeamPage={teamPage} initialClassPage={classPage} initialGuidePage={guidePage} /></React.StrictMode>
  );
}
mount().catch(error => console.error('Kunde inte starta sidan', error));
